import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ShopContextProvider from './Context/ShopContext';

// In development, prevent unhandled promise rejections (like failed fetch)
// from crashing the React app with a runtime error overlay.
// This does NOT run in the production build used on cPanel.
if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault();
  });
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ShopContextProvider>
    <App />
  </ShopContextProvider>
);

